import { useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import { useFetcher } from '../hooks/useFetcher';
import ProductRowFetcher from '../components/Product-Row-Fetcher';
import { ReactComponent as BackIcon } from '../assets/icons/back.svg';
import ImageCarousel from '../components/CardImageCarousel';


const Product = () => {
  const params = useParams();
  
  const [data, loading] = useFetcher(`products/${params.id}`);
  const [cart, setCart] = useState(null);
  const [number,setNumber] = useState(1);
  const [rerender, setRerender] = useState(false);

  function toFarsiNumber(n) {
    const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

    return parseInt(n)
      .toLocaleString()
      .toString()
      .replace(/\d/g, (x) => farsiDigits[x]);
  }

  const isInArray = (source, item) => {
    const checkId = (obj) => obj.id === item.id;
    return source.some(checkId);
  };

  const addToCart = (item) => {
    let newData = [];
    const lsData = JSON.parse(localStorage.getItem('products'));
    item.count=number;
    if (lsData) {
      if (isInArray(lsData, item)) {
        newData = lsData.filter((product) => product.id !== item.id);
      } else {

        newData = [...lsData, item];
      }
    } else {
      newData = [item];
    }

    setCart(newData);
    setRerender((prev) => !prev);
    localStorage.setItem('products', JSON.stringify(newData));
  };



  const goback = () => {
    window.history.go(-1);
  };

  useEffect(() => {
    setCart(() => {
      return JSON.parse(localStorage.getItem('products'));
    });
  }, [data, rerender]);
  
  const maxCartSelectable=localStorage.getItem('maxCart');
  if (loading) {
    return <div className='lds-dual-ring'></div>;
  }
  
  return (
    <div className='container flex flex-col items-center my-5'>
      <BackIcon className='h-10 self-start cursor-pointer' onClick={goback} />

      {/* Card */}
      <div
        className='w-3/4 h-fit p-1 sm:p-5 sm:pr-10 pt-4 flex flex-col sm:flex-row justify-between items-center bg-white shadow-md'
        style={{ minHeight: '20rem' }}>
        <div className='w-5/6 sm:h-72 sm:h-full sm:p-5'>
          {data.images.length > 1 ? (
            <ImageCarousel data={data.images} />
          ) : (
            <img className='h-full mx-auto' src={data.images[0]} alt='' />
          )}
        </div>
        <div
          className='sm:w-1/2 h-full flex flex-col justify-between gap-2'
          style={{ minHeight: '18rem' }}>
          <span className='text-right font-bold'>{data.name}</span>
          <div className='flex flex-col text-right'>
            <span>تولید کننده: {data.brand_title}</span>
            <span>
              وزن خالص:{' '}
              {data.weight < 1
                ? toFarsiNumber(data.weight * 1000) + ' گرم'
                : toFarsiNumber(data.weight) + ' کیلوگرم'}
            </span>
            <span style={{direction: 'rtl'}}>توضیحات: {data.description || 'بدون توضیح'}</span>
            <span>قیمت: {toFarsiNumber(data.price)} تومان</span>
          </div>
          <div className='flex items-center'>
            
            <button
              className={`add_to_cart_box  mb-4 p-2 rounded-md text-white ${
                data.isAvailable>0 ? cart && isInArray(cart, data) ? 'remove_cart bg-red-600' : 'add_to_cart bg-green-600':''
              } ${data.isAvailable <= 0 && 'remove_cart bg-gray-500'}`}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                addToCart(data);
              }}
              disabled={data.isAvailable <= 0}>
              {cart && isInArray(cart, data)
                ? 'حذف از سبد'
                : 'افزودن به سبد خرید'}
            </button>
            {!(cart && isInArray(cart, data) || data.isAvailable <= 0) &&
            <><button 
            className={`add_to_cart_box add_to_cart_plus mb-4 p-2 m-0  text-white ${data.pcount-1==number?'bg-gray-600':'bg-green-600'}`}
            disabled={Math.min(data.pcount-1,maxCartSelectable)==number}
            onClick={(e) =>{
              //console.log(data.pcount);
              if(number<data.pcount-1)
              setNumber(number+1);  
            }}>+</button>
          
            <span className={`add_to_cart_box bg-green-600 w-5 text-center mb-4 pt-2 pb-2 m-0  text-white`} id='cart_number'>{number}</span>
            <button 
            className={`add_to_cart_box bg-green-600 add_to_cart_minus mb-4 p-2 m-0 rounded-md text-white ${number==1?'bg-gray-600':'bg-green-600'}`}
            
            onClick={(e) =>{
              if(number>1) setNumber(number-1);
            }}>-</button></>
          }
            {/* <div className="flex justify-between px-5 gap-0.5">
              <button
                onClick={decrease}
                className="w-6 bg-gray-300 px-2 rounded-sm"
              >
                -
              </button>
              <span className="w-6 bg-gray-200 px-2 rounded-sm">{count}</span>
              <button
                onClick={increase}
                className="w-6 bg-gray-300 px-2 rounded-sm"
              >
                +
              </button>
            </div> */}
          </div>
        </div>
      </div>

      <ProductRowFetcher
        rerender={rerender}
        products={`products?cat=${data.cat_id}`}
        callBack={setRerender}
      />
    </div>
  );
};

export default Product;
